import { useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { PaymentModal } from '../components/customer/PaymentModal'
import { usePaymentModalStore } from '../store/paymentModalStore'

/**
 * Customer-facing layout (landing, payment, dashboard).
 * Renders global PaymentModal; opening via store or /payment → redirect to / with modal open.
 * Panel switching (Customer / Company / Admin) is in the main Navigation user menu only.
 */
export default function CustomerLayout() {
  const location = useLocation()
  const navigate = useNavigate()
  const { open: paymentModalOpen, openModal, closeModal } = usePaymentModalStore()

  // When we land on any page with state.openPaymentModal (e.g. after /payment or /pay/internal/:id), open modal and clear state
  useEffect(() => {
    if (location.state?.openPaymentModal) {
      const preloadUrl = location.state?.preloadUrl as string | undefined
      openModal(preloadUrl ? { preloadUrl } : undefined)
      navigate(location.pathname, { replace: true, state: {} })
    }
  }, [location.state?.openPaymentModal, location.pathname, openModal, navigate])

  return (
    <>
      <Outlet />
      <PaymentModal isOpen={paymentModalOpen} onClose={closeModal} />
    </>
  )
}
